import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import logo from "../assets/logoly2.webp";

const Header = ({ inviteeData, isArabic }) => {
  // Create refs for each element
  const logoRef = useRef(null);
  const textRefs = useRef([]);
  textRefs.current = [];

  // Add each ref to the array
  const addToRefs = (el) => {
    if (el && !textRefs.current.includes(el)) {
      textRefs.current.push(el);
    }
  };

  useEffect(() => {
    const timeline = gsap.timeline();

    // Staggered animation for each element in the header
    timeline
      .fromTo(
        logoRef.current,
        { opacity: 0, y: -50 },
        { opacity: 1, y: 0, duration: 1 }
      )
      .fromTo(
        textRefs.current,
        { opacity: 0, y: 30 },
        { opacity: 1, y: 0, stagger: 0.3, duration: 1, ease: 'power2.out' }
      );
  }, []);

  return (
    <div className="w-full flex flex-col gap-3 px-4 pt-2 justify-center items-center text-center text-text2">
      <img ref={logoRef} className="w-[10%]" src={logo} />

      {/* <div ref={addToRefs} className="font-bold md:text-xl text-text">
        {isArabic
          ? 'بارك الله لهما و بارك عليهما و جمع بينهما في خير'
          : 'May Allah bless them both and bring them together in kindness'}
      </div> */}
      {/* {inviteeData && (
        <div ref={addToRefs} className="font-bold md:text-xl">
          {isArabic?inviteeData.inviteTitleAr:inviteeData.inviteTitle}
        </div>
      )} */}
      {/* <div ref={addToRefs} className="font-bold md:text-xl">
        {isArabic ? 'يتشرف' : 'With Pleasure'}
      </div> */}
      {/* <div ref={addToRefs} className="grid grid-cols-3 justify-items-center text-xs my-10 md:text-3xl w-full md:w-2/3">
        <div className="w-full">
          <div>{isArabic ? 'المهندس أكمل حسين' : 'Eng. Akmal Hussein'}</div>
          <div>{isArabic ? 'وحرمه رانيا خليل' : 'Mrs. Rania Khalil'}</div>
        </div>
        <div className="text-2xl md:text-7xl">{isArabic ? 'و' : '&'}</div>
        <div className="w-full">
          <div>{isArabic ? 'المهندس نائل دجاني' : 'Eng. Nael Dajani'}</div>
          <div>{isArabic ? 'وحرمه هند الهندي' : 'Mrs. Hind ElHindy'}</div>
        </div>
      </div> */}
      {/* <div ref={addToRefs} className="font-bold text-xl">
        {isArabic
          ? 'بدعوتكم لحضور حفل زفاف'
          : 'Invite you to celebrate a new beginning, a new dream and most importantly, love.'}
      </div> */}
      <div ref={addToRefs} className="font-bold text-sm md:text-base">
        {isArabic ? 'بوجودكم تكتمل فرحتنا' : "We can’t wait to share our special day with you."}
      </div>
      <div
        ref={addToRefs}
        className={`grid grid-cols-5 ${isArabic?'':'mb-4'} md:my-10 justify-items-center place-items-center  w-full md:w-2/3 text-textgold ${
          isArabic ? ' fontal text-6xl md:text-9xl' : ' Liana text-4xl md:text-6xl'
        }`}
      >
        <div className="w-full col-span-2">
          <div>{isArabic ? 'يوسف' : 'Youssef'}</div>
        </div>
        <div className="text-3xl md:text-7xl col-span-1">{isArabic ? 'و' : '&'}</div>
        <div className="w-full col-span-2">
          <div>{isArabic ? 'لارا' : 'Lara'}</div>
        </div>
      </div>
      <div
        ref={addToRefs}
        className="w-10/12 md:w-2/3 flex flex-col items-center justify-center gap-3 text-2xl"
      >
        
        <div
          className={`grid grid-cols-3 justify-items-center md:text-4xl place-items-center ${
            isArabic ? 'BFantezyRegular' : ''
          }`}
        >
          <div className="w-full border-t-2 py-4 px-2 border-b-2 border-black">
            
            {isArabic ? '٣ ینایر ' : 'Jan. 3'}
          </div>
          <div className={` ${isArabic&&'emiratesmedium'} text-xs gap-2 w-full py-6 mx-8 px-2 md:text-xl flex flex-col`}>
            <div>{isArabic ? 'الجمعة' : 'Friday'}</div>
            <div>{isArabic ? 'الساعة ٨ مساءً' : '8 PM'}</div>
          </div>
          <div className="w-full border-t-2 py-4 px-2 border-b-2 border-black">
            {isArabic ? '٢٠٢٥' : '2025'}
          </div>
        </div>
        {/* <div className="text-lg mt-5 md:text-2xl">
          
            Waldorf Astoria Cairo Heliopolis
        </div>
        <div>{isArabic ? 'مدينة القاهرة, مصر' : 'Cairo, Egypt'}</div> */}
        
      </div>
    </div>
  );
};

export default Header;
